module.exports = __webpack_public_path__ + "img/2020_20200118_120508.18467e54.jpg";